import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
    Form,
    Button,
    Container,
    Row,
    Col,
    Card,
    Modal,
    InputGroup,
} from "react-bootstrap";
import { register } from "../../services/api";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { EnvelopeCheckFill } from "react-bootstrap-icons";
import AOS from "aos";
import "aos/dist/aos.css";
import { trackEvent } from '../../components/Tools/analytics';
import logo from "../../assets/Logo-Thinail.png";
import "./register.css";

const Register = () => {
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [error, setError] = useState(null);
    const [emailError, setEmailError] = useState(null);
    const [passwordError, setPasswordError] = useState(null);
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [showConfirmationModal, setShowConfirmationModal] = useState(false);
    const [isAgree, setIsAgree] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const navigate = useNavigate();

    const apiBase = process.env.REACT_APP_API_BASE || 'http://localhost:5000';

    useEffect(() => {
        AOS.init({
            duration: 1000,
            once: true,
        });
    }, []);

    const validateEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setEmailError(null);
        setPasswordError(null);
        setError(null);

        if (password.length < 8) {
            setPasswordError("Mật khẩu phải có ít nhất 8 ký tự.");
            return;
        }

        if (password !== confirmPassword) {
            setPasswordError("Mật khẩu không khớp.");
            return;
        }

        if (!validateEmail(email)) {
            setEmailError("Email không hợp lệ.");
            return;
        }

        setIsSubmitting(true);

        try {
            await register({ firstName, lastName, email, password });
            setShowConfirmationModal(true);
        } catch (error) {
            setIsSubmitting(false);
            if (error.response && error.response.status === 409) {
                setError("Email đã được sử dụng.");
            } else {
                setError("Đăng ký thất bại. Vui lòng thử lại.");
            }
        }
    };

    const handleGoogleRegister = () => {
        trackEvent('Clicked Google Register');
        window.location.href = `${apiBase}/auth/google`;
    };

    const handleCloseModal = () => {
        setShowConfirmationModal(false);
        navigate("/login");
    };

    const handleTermsOfServiceClick = () => {
        navigate("/terms-of-service");
    };

    return (
        <div className="register-page-container min-vh-100 d-flex align-items-center justify-content-center">
            <Container className="register-container">
                <Row className="justify-content-md-center">
                    <Col md={10} lg={8} xl={6} data-aos="fade-up">
                        <Card className="register-card border-0 shadow-lg">
                            <Card.Body className="p-md-5 p-4">
                                <div className="text-center mb-4">
                                    <a href="/" className="login-logo">
                                        <img src={logo} alt="Thinail Logo" className="logo-image" />
                                    </a>
                                    <h2 className="register-title" data-aos="fade-right">
                                        Tạo Tài Khoản
                                    </h2>
                                    <p className="register-subtitle text-muted">Tạo tài khoản để bắt đầu hành trình chinh phục chứng chỉ Nail</p>
                                </div>
                                
                                {error && (
                                    <div className="error-message" data-aos="fade-left">
                                        {error}
                                    </div>
                                )}
                                
                                <Form onSubmit={handleSubmit} data-aos="zoom-in">
                                    <Row>
                                        <Col>
                                            <Form.Group controlId="formFirstName" className="mb-3">
                                                <Form.Control
                                                    type="text"
                                                    value={firstName}
                                                    onChange={(e) => setFirstName(e.target.value)}
                                                    placeholder="Họ"
                                                    required
                                                    className="form-input"
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col>
                                            <Form.Group controlId="formLastName" className="mb-3">
                                                <Form.Control
                                                    type="text"
                                                    value={lastName}
                                                    onChange={(e) => setLastName(e.target.value)}
                                                    placeholder="Tên"
                                                    required
                                                    className="form-input"
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>

                                    <Form.Group controlId="formEmail" className="mb-3">
                                        <Form.Control
                                            type="email"
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                            placeholder="Nhập email"
                                            isInvalid={!!emailError}
                                            required
                                            className="form-input"
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            {emailError}
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    <Form.Group controlId="formPassword" className="mb-3">
                                        <InputGroup>
                                            <Form.Control
                                                type={showPassword ? "text" : "password"}
                                                value={password}
                                                onChange={(e) => setPassword(e.target.value)}
                                                placeholder="Mật khẩu"
                                                required
                                                className="form-input"
                                                isInvalid={!!passwordError}
                                            />
                                            <div
                                                onClick={() => setShowPassword(!showPassword)}
                                                className="password-toggle-btn "
                                            >
                                                {showPassword ? <FaEyeSlash /> : <FaEye />}
                                            </div>
                                            <Form.Control.Feedback type="invalid">
                                                {passwordError}
                                            </Form.Control.Feedback>
                                        </InputGroup>
                                    </Form.Group>

                                    <Form.Group controlId="formConfirmPassword" className="mb-3">
                                        <InputGroup>
                                            <Form.Control
                                                type={showConfirmPassword ? "text" : "password"}
                                                value={confirmPassword}
                                                onChange={(e) => setConfirmPassword(e.target.value)}
                                                placeholder="Xác nhận mật khẩu"
                                                isInvalid={!!passwordError}
                                                required
                                                className="form-input"
                                            />
                                            <div
                                                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                                className="password-toggle-btn"
                                            >
                                                {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                                            </div>
                                        </InputGroup>
                                    </Form.Group>

                                    <Form.Group className="mb-4" controlId="formBasicCheckbox">
                                        <Form.Check
                                            type="checkbox"
                                            label={<>
                                                Tôi đã đọc và đồng ý với {" "}
                                                <span
                                                    className="terms-link"
                                                    onClick={handleTermsOfServiceClick}
                                                >
                                                    Điều khoản dịch vụ
                                                </span>
                                            </>}
                                            checked={isAgree}
                                            onChange={() => setIsAgree(!isAgree)}
                                            required
                                        />
                                    </Form.Group>

                                    <Button
                                        variant="primary"
                                        type="submit"
                                        className="register-btn w-100 mb-3"
                                        disabled={!isAgree || isSubmitting}
                                        data-aos="fade-up"
                                    >
                                        {isSubmitting ? "Đang Đăng Ký..." : "Đăng Ký"}
                                    </Button>

                                    <div className="divider my-4">
                                        <span>hoặc</span>
                                    </div>

                                    <Button
                                        variant="outline-danger"
                                        onClick={handleGoogleRegister}
                                        className="google-register-btn w-100 mb-4"
                                        data-aos="fade-up"
                                    >
                                        <img
                                            src="https://developers.google.com/identity/images/g-logo.png"
                                            alt="Google logo"
                                            className="google-icon"
                                        />
                                        Đăng ký bằng Google
                                    </Button>
                                    
                                    <div className="text-center">
                                        <p className="mb-0">
                                            Đã có tài khoản? 
                                            <a href="/login" className="login-link ms-1">
                                                Đăng nhập ngay <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-arrow-right"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>
                                            </a>
                                        </p>
                                    </div>
                                </Form>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>

            <Modal
                show={showConfirmationModal}
                onHide={handleCloseModal}
                centered
                className="confirmation-modal"
                data-aos="fade-in"
            >
                <Modal.Header closeButton className="border-0">
                    <Modal.Title className="w-100 text-center">Xác Nhận Email</Modal.Title>
                </Modal.Header>
                <Modal.Body className="text-center py-4">
                    <div className="email-icon-wrapper">
                        <EnvelopeCheckFill className="email-icon" />
                    </div>
                    <h4 className="modal-heading mb-3">Cảm ơn bạn đã đăng ký!</h4>
                    <p className="mb-2">Chúng tôi đã gửi một email xác nhận đến:</p>
                    <p className="email-highlight mb-3">{email}</p>
                    <p>Vui lòng kiểm tra hộp thư đến của bạn trong ít phút và nhấp vào liên kết xác nhận để hoàn tất quá trình đăng ký.</p>
                    <p>Nếu bạn không thấy email, vui lòng kiểm tra mục Spam hoặc Thư rác.</p>
                </Modal.Body>
                <Modal.Footer className="border-0 justify-content-center pb-4">
                    <Button variant="primary" onClick={handleCloseModal} className="modal-btn px-4 py-2">
                        Đóng và Đăng nhập
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default Register;